<div class="ms-xlarge-b">
  @if (type === 'CAR_TRAWLER_RENTAL') {
    <cms-unstyled-fragment
      [contentUrl$]="notificationContentUrl$"
      [showIcon]="true"
      class="block"
    ></cms-unstyled-fragment>
  }
  @if (type === 'EXPEDIA_HOTEL') {
    <div>
      <p>
        {{ 'bookingWidgetTabs.hotels.staticNotification.content' | finLocalization }}
      </p>
      @if (nonMatchingProviderLocale) {
        <p class="pr-medium-t">
          {{ 'bookingWidgetTabs.hotels.staticNotification.redirect' | finLocalization }}
        </p>
      }
    </div>
  }
</div>
<div class="flex flex--middle flex--space-between flex--nowrap font-body-1 ms-medium-b">
  <div class="flex flex--wrap">
    <div class="ps-xxsmall-r">
      {{ config.poweredByTranslationKey | finLocalization }}
    </div>
    <fcom-icon class="provider-logo" [category]="IconLibrary.CUSTOM" [name]="config.logoIcon"></fcom-icon>
  </div>
  <fcom-button
    [text]="config.ctaTranslationKey | finLocalization"
    [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
    [href]="redirectUrl"
    [openInNewTab]="true"
    [externalLink]="true"
    (click)="trackClick()"
    (keydown)="trackClick()"
  ></fcom-button>
</div>

<fcom-notification [layout]="NotificationLayout.BLOCK" [iconName]="SvgLibraryIcon.AVIOS_PLECTRUM">
  <p class="medium-type">
    {{ config.aviosNotificationTranslationKey | finLocalization }}
  </p>
</fcom-notification>
